import siteApi from '@/api/site'

const state = {
  site: {
    level_0: [],
    level_1: [],
    level_2: []
  },
}

const mutations = {
  UPDATE_SITE (pState, payload) {
    pState.site[`level_${payload.index}`] = payload.result.data
  }
}

const getters = {
  siteConnectionLevelFirst: state => state.site.level_0,
  siteConnectionLevelSecond: state => state.site.level_1,
  siteConnectionLevelThird: state => state.site.level_2
}

const actions = {
  async getConnectionSite ({ commit }) {
    const result = await Promise.all([
        siteApi.getConnectionSite(1),
        siteApi.getConnectionSite(2),
        siteApi.getConnectionSite(3),
    ])

    result.forEach((item, index) => {
      commit('UPDATE_SITE', {
        result: item,
        index: index
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
